import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, LogIn, BookOpen } from "lucide-react";
import { LOGO_URL, NAV_ITEMS, CONTACT } from "../data/mock";
import { Button } from "./ui/button";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-slate-200/70 shadow-[0_8px_30px_-12px_rgba(16,42,107,0.18)]"
          : "bg-white/60 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-20 flex items-center justify-between">
        <a href="/" className="flex items-center gap-3 group">
          <div className="relative h-12 w-12 rounded-xl bg-white border border-slate-200 shadow-sm overflow-hidden flex items-center justify-center">
            <img
              src={LOGO_URL}
              alt="A.C.D.T. logo"
              className="h-11 w-11 object-contain"
            />
          </div>
          <div className="leading-tight">
            <div className="text-[15px] font-extrabold tracking-wide text-[#0a1f55]">A.C.D.T.</div>
            <div className="text-[10.5px] uppercase tracking-[0.18em] text-slate-500 -mt-0.5">
              Associazione Digitale
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="relative text-sm font-medium text-slate-700 hover:text-[#102a6b] transition-colors"
            >
              <span>{n.label}</span>
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-gradient-to-r from-[#102a6b] to-[#f59e0b] transition-all duration-300 group-hover:w-full hover:w-full"></span>
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <Link to="/area-soci">
            <Button
              data-testid="navbar-accesso-soci"
              className="bg-[#1e40af] hover:bg-[#1e3a8a] text-white font-bold shadow-md"
            >
              <LogIn className="mr-1.5 h-4 w-4" />
              Accesso Soci
            </Button>
          </Link>
        </div>

        <button
          className="lg:hidden p-2 rounded-md text-[#102a6b]"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-300 bg-white border-t border-slate-100 ${
          open ? "max-h-[480px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-5 py-4 flex flex-col gap-3">
          {NAV_ITEMS.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-slate-700 py-1"
            >
              {n.label}
            </a>
          ))}
          <Link to="/area-soci" onClick={() => setOpen(false)}>
            <Button data-testid="navbar-mobile-accesso-soci" className="w-full bg-[#1e40af] hover:bg-[#1e3a8a] text-white font-bold">
              <LogIn className="mr-1.5 h-4 w-4" />
              Accesso Soci
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
